import FadeIn from '../components/FadeIn';
import { Link } from 'react-router-dom';

const IMAGES = {
  bowls: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/60gea409_1000001871.jpg",
  lotus: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/d1t7n4w6_website%20photo%20one.png",
  gong: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/alpxg7xy_website%20photo%203.jpg",
  indoor: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/bdoytqmu_website%20photo%204.jpg",
};

const INDIVIDUAL_SERVICES = [
  {
    name: 'Hypnotherapy',
    desc: 'A deeply relaxed, focused state that allows access to the subconscious mind where habits, beliefs, and emotional responses are stored. Together, we gently re-frame and release patterns to support lasting change, clarity, and inner alignment.',
    detail: '2 hour session',
    cta: 'Book Session',
    link: 'https://buy.stripe.com/3cI28qePl3WgabyglN3ks00',
  },
  {
    name: 'Shadow Work',
    desc: 'A guided space to explore and integrate the unconscious patterns, emotions, and beliefs that may be influencing your life. Through compassionate awareness, we bring light to what\'s been hidden so you can move with greater clarity, self-acceptance, and emotional freedom.',
    detail: '90 minute session',
    cta: 'Start Integrating',
    link: 'https://buy.stripe.com/bJe8wObD98cw97u7Ph3ks01',
  },
  {
    name: 'Sound Bath',
    desc: 'An immersive, full-body listening experience using layered sound frequencies to guide you into deep relaxation and nervous system regulation. These sessions support emotional release, energetic reset, and a return to inner stillness and balance with the use of quartz crystal bowls and other sacred instruments.',
    detail: 'Private session · Contact us for group or event pricing',
    cta: 'Book Session',
    link: 'https://buy.stripe.com/7sY9ASgXt8cw97u1qT3ks02',
  },
  {
    name: 'Reiki',
    subtitle: 'Distance or In-Person',
    desc: 'A gentle, energy-based practice that supports balance, relaxation, and energetic alignment; whether received in person or from a distance. These sessions work beyond physical space to calm the nervous system, release energetic blockages, and restore a sense of harmony within the body and mind.',
    detail: 'Distance or in-person',
    cta: 'Book Session',
    link: 'https://buy.stripe.com/aFaeVc9v1csM97u6Ld3ks03',
  },
  {
    name: 'Tuning Fork',
    desc: 'A vibrational healing modality that uses sound frequencies to bring the body and energy field into harmony. This work can help calm the nervous system, release energetic blockages, and restore a sense of balance and clarity. They can also be used hands-on, applying a gentle pressure on specific points of the body to support energy flow and physical balance. This practice can help relieve tension, reduce stress, and support overall well-being.',
    detail: null,
    cta: 'Book Session',
    link: 'https://buy.stripe.com/7sYcN4bD90K46Zm9Xp3ks04',
  },
];

const SERVICES = [
  {
    tag: 'Deep & Long-Term',
    title: 'Private Containers',
    subtitle: 'A high-touch, personalized space for deep and lasting transformation',
    paragraphs: [
      'Private Containers are a dedicated relational space designed for those who are ready to commit to a deeper, more sustained process of healing and integration.',
      'This is not a single session or a short course—it is an ongoing, personalized container in which we work together over an extended period of time.',
      'Within this container, we move at the pace that your nervous system can hold. We work across the layers—regulating, revealing, rewiring, and reintegrating—as your system becomes ready.',
    ],
    includes: [
      'Ongoing private sessions tailored to your individual process',
      'Nervous system regulation and somatic support',
      'Subconscious pattern work and energetic alignment',
      'Between-session support and integration guidance',
      'Customized approaches based on your unique needs',
    ],
    img: IMAGES.bowls,
    cta: 'Apply for a Container',
    showCalendly: false,
  },
  {
    tag: 'Focused Support',
    title: 'Private Sessions',
    subtitle: 'Intentional, focused support for specific areas of your process',
    paragraphs: [
      'Private Sessions offer a focused, intentional space to work through a specific pattern, experience, or area of integration.',
      'Whether you are new to this kind of work or returning to address a particular aspect of your process, private sessions offer dedicated, personalized support.',
      'Each session is a complete experience—grounded in nervous system awareness, subconscious exploration, and energetic attunement. Conducted with presence, safety, and deep care for where you are.',
    ],
    includes: [
      'Trauma-informed nervous system support',
      'Subconscious exploration and pattern awareness',
      'Energetic field work and alignment',
      'Space for integration and grounded reflection',
      'Personalized approach for each individual session',
    ],
    img: IMAGES.lotus,
    cta: 'Apply for Sessions',
    showCalendly: true,
  },
  {
    tag: 'Ceremony & Group',
    title: 'Sacred Ceremonies',
    subtitle: 'Intentional, guided experiences for release, reconnection, and energetic reset',
    paragraphs: [
      'Sacred Ceremonies are intentional, guided experiences designed to support release, reconnection, and energetic reset.',
      'These ceremonies draw on sound, intention, and energetic alignment to create a held space for transformation.',
      'Ceremonies may include sound healing, group or private formats, and seasonal or intentional offerings—each created with reverence, purpose, and deep attunement.',
    ],
    includes: [
      'Sound healing with crystal bowls and ceremonial instruments',
      'Intentional guidance for release and reconnection',
      'Private and group ceremony offerings',
      'Energetic clearing and reset support',
      'Pre and post-ceremony integration space',
    ],
    img: IMAGES.gong,
    cta: 'Inquire About Ceremonies',
    showCalendly: true,
  },
];

const ServicesPage = () => {
  return (
    <div data-testid="services-page" style={{ background: '#F7F4EF' }}>

      {/* Hero Banner */}
      <div className="pt-40 pb-24 text-center" style={{ background: '#EAE3D9' }}>
        <FadeIn>
          <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>How We Work</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl" style={{ color: '#2B2B2B' }}>
            Ways to Work Together
          </h1>
          <p
            className="text-base mt-6 max-w-2xl mx-auto px-6 leading-relaxed"
            style={{ color: 'rgba(43,43,43,0.68)', fontFamily: 'Inter, sans-serif' }}
          >
            Each offering is designed to meet you where you are and support the depth of transformation your system is ready for.
          </p>
        </FadeIn>
      </div>

      {/* Services */}
      {SERVICES.map((service, i) => (
        <section
          key={service.title}
          data-testid={`service-section-${i}`}
          className="py-24 md:py-32"
          style={{ background: i % 2 === 0 ? '#F7F4EF' : '#EAE3D9' }}
        >
          <div className="max-w-6xl mx-auto px-6 md:px-12">
            <div className="grid md:grid-cols-2 gap-16 items-start">
              <FadeIn className={i % 2 !== 0 ? 'md:order-2' : ''}>
                <div className="overflow-hidden rounded-3xl" style={{ boxShadow: '0 20px 60px rgba(126,140,116,0.12)' }}>
                  <img
                    src={service.img}
                    alt={service.title}
                    className="w-full object-cover img-hover"
                    style={{ height: '480px' }}
                  />
                </div>
              </FadeIn>

              <FadeIn delay={200} className={i % 2 !== 0 ? 'md:order-1' : ''}>
                <span className="text-xs tracking-[0.3em] uppercase font-medium" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>
                  {service.tag}
                </span>
                <h2 className="font-serif text-3xl sm:text-4xl mt-3 mb-3" style={{ color: '#2B2B2B' }}>
                  {service.title}
                </h2>
                <p className="text-base italic mb-7" style={{ color: 'rgba(43,43,43,0.6)', fontFamily: 'Inter, sans-serif' }}>
                  {service.subtitle}
                </p>
                <div className="space-y-4 mb-10">
                  {service.paragraphs.map((para, j) => (
                    <p key={j} className="text-sm leading-relaxed" style={{ color: 'rgba(43,43,43,0.76)', fontFamily: 'Inter, sans-serif' }}>
                      {para}
                    </p>
                  ))}
                </div>

                <div className="mb-10">
                  <p className="text-xs tracking-[0.2em] uppercase font-medium mb-5" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>
                    This Includes
                  </p>
                  <div className="space-y-3">
                    {service.includes.map((item, j) => (
                      <div key={j} className="flex items-start gap-3">
                        <div className="flex-shrink-0 mt-2" style={{ width: '16px', height: '1px', background: '#C6A96B' }} />
                        <p className="text-sm leading-relaxed" style={{ color: 'rgba(43,43,43,0.73)', fontFamily: 'Inter, sans-serif' }}>
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-wrap gap-4 items-center">
                  {/* Individual session listings — Private Sessions only */}
                  {service.title === 'Private Sessions' && (
                    <div className="w-full mb-2">
                      <div style={{ width: '100%', height: '1px', background: 'rgba(198,169,107,0.25)', marginBottom: '28px' }} />
                      <p className="text-xs tracking-[0.25em] uppercase font-medium mb-6" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>
                        Available Sessions
                      </p>
                      <div className="space-y-4 mb-8">
                        {INDIVIDUAL_SERVICES.map((svc, k) => (
                          <FadeIn key={k} delay={k * 80}>
                            <div
                              className="rounded-2xl p-6"
                              style={{ background: i % 2 === 0 ? '#EAE3D9' : '#F7F4EF', boxShadow: '0 4px 20px rgba(126,140,116,0.07)' }}
                            >
                              <div className="flex flex-wrap items-start justify-between gap-4">
                                <div className="flex-1 min-w-0">
                                  <div className="flex flex-wrap items-center gap-3 mb-2">
                                    <h4 className="font-serif text-lg" style={{ color: '#2B2B2B' }}>{svc.name}</h4>
                                    {svc.subtitle && (
                                      <span className="text-xs px-3 py-1 rounded-full" style={{ background: 'rgba(198,169,107,0.15)', color: '#C6A96B', fontFamily: 'Inter, sans-serif' }}>
                                        {svc.subtitle}
                                      </span>
                                    )}
                                  </div>
                                  <p className="text-sm leading-relaxed mb-3" style={{ color: 'rgba(43,43,43,0.7)', fontFamily: 'Inter, sans-serif' }}>
                                    {svc.desc}
                                  </p>
                                  {svc.detail && (
                                    <p className="text-xs" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif', fontStyle: 'italic' }}>
                                      {svc.detail}
                                    </p>
                                  )}
                                </div>
                                <a
                                  href={svc.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  data-testid={`session-book-${k}`}
                                  className="flex-shrink-0 rounded-full text-xs font-medium transition-all duration-300 hover:opacity-85 whitespace-nowrap"
                                  style={{ background: '#A8B5A2', color: '#2B2B2B', padding: '10px 22px', fontFamily: 'Inter, sans-serif' }}
                                >
                                  {svc.cta}
                                </a>
                              </div>
                            </div>
                          </FadeIn>
                        ))}
                      </div>
                    </div>
                  )}
                  {!service.showCalendly && (
                    <a
                      href="https://forms.gle/acnQmapg39FqW7wL7"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`service-cta-${i}`}
                      className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
                      style={{ background: '#A8B5A2', color: '#2B2B2B', padding: '14px 34px', fontFamily: 'Inter, sans-serif' }}
                    >
                      {service.cta}
                    </a>
                  )}
                  {service.showCalendly && (
                    <a
                      href="https://calendly.com/jennie-resonanthealing444/30-minute-discovery-call"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`service-calendly-${i}`}
                      className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
                      style={{ background: '#C6A96B', color: '#2B2B2B', padding: '14px 34px', fontFamily: 'Inter, sans-serif' }}
                    >
                      Book a Discovery Call
                    </a>
                  )}
                </div>
              </FadeIn>
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section data-testid="services-cta-section" className="py-24 text-center" style={{ background: '#7E8C74' }}>
        <div className="max-w-2xl mx-auto px-6">
          <FadeIn>
            <p className="text-xs tracking-[0.3em] uppercase font-medium mb-6" style={{ color: 'rgba(247,244,239,0.65)', fontFamily: 'Inter, sans-serif' }}>
              Ready to Begin
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl mb-6" style={{ color: '#F7F4EF' }}>
              Find Your Path Forward
            </h2>
            <p className="text-base mb-10 leading-relaxed" style={{ color: 'rgba(247,244,239,0.75)', fontFamily: 'Inter, sans-serif' }}>
              If any of these offerings feel aligned with where you are, you're invited to apply.
            </p>
            <a
              href="https://forms.gle/acnQmapg39FqW7wL7"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="services-apply-btn"
              className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
              style={{ background: '#C6A96B', color: '#2B2B2B', padding: '16px 42px', fontFamily: 'Inter, sans-serif' }}
            >
              Apply to Work Together
            </a>
          </FadeIn>
        </div>
      </section>

    </div>
  );
};

export default ServicesPage;
